<div class="widget__wrap">
  <div class="widget" id="storyboards-widget">
    <h2 class="widget__header">
      <span class="widget__header__title">
        <i class="widget__header__icon ico-angle-down"></i> Storyboardy</span
      >
      <span class="widget__header__tools">
        <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
        <a
          [routerLink]="['storyboards/add']"
          class="cta cta--small cta--green"
        >
          <span class="cta__light">Přidat</span> board <i class="ico-plus"></i>
        </a>
      </span>
    </h2>
    <div class="widget__content">
      <swb-storyboards-list [query]="query"></swb-storyboards-list>
    </div>
  </div>
</div>
